import { NotifyHelper } from "../../../helpers/toast";
import { eGachNoThuCongActionsObj } from "../../action-types/dong-bo/IGachNoThuCongAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const gachNoThuCongActions = {
  ...generateActions(eGachNoThuCongActionsObj, "GACH_NO_THU_CONG"),
  ...generateActionForKey(
    eGachNoThuCongActionsObj,
    "GACH_NO_THU_CONG",
    "GACH_NO_SUCCESS",
    (m) => {
      NotifyHelper.Success("Hoàn thành");
    },
  ),
  ...generateActionForKey(
    eGachNoThuCongActionsObj,
    "GACH_NO_THU_CONG",
    "GACH_NO_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Thất bại");
    },
  ),
};
